import { Component } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import styles from "./platform_edit_field.module.scss"
import parse from "html-react-parser"

export default class PlatformEditField extends Component {
  render() {
    return (
      <div
        className={classnames(styles["edit-field-container"], {
          [styles["selectable-field"]]:
            this.props.fieldCallback && this.props.fieldEnabled,
        })}
        onClick={this.props.fieldCallback && this.props.fieldCallback}
      >
        {this.props.title}
        <span className={classnames("button-container", styles["button-container"])}>
          {this.props.actions &&
            this.props.fieldEnabled &&
            this.props.actions.map((action, key) => {
              return (
                <span
                  className={classnames("edit-field-button", styles["edit-field-button"], {
                    [styles["final-button"]]:
                      key == this.props.actions.length - 1,
                  })}
                  key={key}
                  onClick={action.callback}
                >
                  {parse(action.icon)}
                </span>
              )
            })}
        </span>
      </div>
    )
  }
}

PlatformEditField.propTypes = {
  title: PropTypes.string,
  actions: PropTypes.arrayOf(PropTypes.object),
  fieldEnabled: PropTypes.bool,
  fieldCallback: PropTypes.func,
}

PlatformEditField.defaultProps = {
  fieldEnabled: true,
}
